import React from "react";
import TailwindPageWrapper from "../components/generic/TailwindPageWrapper";
import SponsorsPartners from "../components/sponsorDetailsPage/SponsorsPartners";

function SponsorsPartnersPage() {
  return (
    <TailwindPageWrapper>
      <div>
        <SponsorsPartners />
      </div>
    </TailwindPageWrapper>
  );
}

export default SponsorsPartnersPage;

